const B2B_CONFIG = window.becherovkaB2B || {}
const FORM_ID = B2B_CONFIG.formId || 'becherovka_b2b'
const DISPLAY_CURRENCY = B2B_CONFIG.currency || (B2B_CONFIG.language === 'cs' ? 'CZK' : 'EUR')
const DELIVERY_SAME_YES_VALUE = B2B_CONFIG.deliverySameYesValue || 'Áno'
const DELIVERY_SAME_NO_VALUE = B2B_CONFIG.deliverySameNoValue || 'Nie'
const TEXT = {
	productStep: 'Výber balení',
	companyStep: 'Spoločnosť',
	companyTitle: 'Fakturačné údaje',
	companyDescription: 'Údaje potrebujeme na prípravu ponuky a následnej predfaktúry.',
	deliveryStep: 'Dodanie',
	deliveryTitle: 'Dodacia adresa',
	deliveryDescription: 'Ak je rovnaká ako fakturačná, ďalšie polia nemusíte vypĺňať.',
	contactStep: 'Kontakt',
	contactTitle: 'Kontaktná osoba',
	contactDescription: 'Na tieto údaje vám tím Maspexu pošle potvrdenie a ďalší postup.',
	personalizationStep: 'Personalizácia',
	personalizationTitle: 'Logo na etiketu',
	personalizationDescription: 'Zobrazuje sa iba pri personalizovanej Becherovke Original 0,5 l.',
	submitStep: 'Odoslanie',
	submitTitle: 'Doplňte detaily a odošlite dopyt',
	submitDescription: 'Pred odoslaním si ešte skontrolujte vybrané balenia a množstvá.',
	reassurance: 'Odoslaním nevzniká objednávka. Tím Maspexu vám následne potvrdí cenu, dostupnosť a ďalší postup.',
	summaryLabel: 'Váš výber',
	summaryEmpty: 'Zatiaľ ste nevybrali žiadne balenie.',
	summaryTotal: 'Spolu',
	summaryEdit: 'Upraviť výber',
	productOne: '{count} produkt',
	productFew: '{count} produkty',
	productMany: '{count} produktov',
	pieces: '{count} ks',
	piecesWithBags: '{pieces} ks + {bags} tašiek',
	pricePerUnit: 'Cena za kus',
	netSuffix: 'bez DPH',
	giftBagChoice: 'Pridať darčekovú tašku ku každej fľaši',
	giftBagUnit: 'za kus',
	giftBagCountAria: 'Počet darčekových tašiek',
	giftBagName: 'Darčeková taška',
	selectedProduct: 'vybraný produkt',
	selectedPackage: 'Vybrané balenie',
	decreaseQuantity: 'Znížiť množstvo',
	increaseQuantity: 'Zvýšiť množstvo',
	quantityFor: 'pre',
	requiredHeading: 'Skontrolujte povinné polia:',
	formErrors: 'Vo formulári sa vyskytli nasledujúce chyby:',
	placeholderDetails: 'Finálny obchodný popis a cena budú doplnené',
	...(B2B_CONFIG.strings || {})
}
const interpolate = (template, values) => Object.entries(values).reduce(
	(output, [key, value]) => output.replaceAll(`{${key}}`, String(value)),
	template
)
const PERSONALIZED_PRODUCT_ID = 'vqc_b2b_personal05'
const GIFT_BAG_PRODUCT_ID = 'vqc_b2b_giftbag'
const CURRENCY_ORDER = ['EUR', 'CZK']
const CURRENCY_LOCALES = { EUR: 'sk-SK', CZK: 'cs-CZ' }

const normalizePrices = card => {
	try {
		const prices = JSON.parse(card?.getAttribute('data-sf-vqc-prices') || '[]')
		return Array.isArray(prices) ? prices
			.filter(price => price.currency === DISPLAY_CURRENCY
				&& Number.isSafeInteger(Number(price.amount_minor))
				&& Number.isInteger(Number(price.minor_unit)))
			.map(price => ({
				currency: price.currency,
				amountMinor: Number(price.amount_minor),
				minorUnit: Number(price.minor_unit),
				taxIncluded: Boolean(price.tax_included),
				taxRateBps: Number(price.tax_rate_bps) || 0
			})) : []
	} catch (error) {
		return []
	}
}

const formatPrice = ({ amountMinor, currency, minorUnit }) => new Intl.NumberFormat(CURRENCY_LOCALES[currency] || 'sk-SK', {
	style: 'currency',
	currency,
	minimumFractionDigits: minorUnit,
	maximumFractionDigits: minorUnit
}).format(amountMinor / (10 ** minorUnit))

const orderedPrices = prices => [...prices].sort((left, right) => CURRENCY_ORDER.indexOf(left.currency) - CURRENCY_ORDER.indexOf(right.currency))
const dualPrice = prices => orderedPrices(prices).map(formatPrice).join(' / ')
const netPrice = price => {
	const divisor = price.taxIncluded ? 1 + (price.taxRateBps / 10000) : 1
	return new Intl.NumberFormat(CURRENCY_LOCALES[price.currency] || 'sk-SK', {
		style: 'currency',
		currency: price.currency,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format((price.amountMinor / (10 ** price.minorUnit)) / divisor)
}
const netDualPrice = prices => orderedPrices(prices).map(price => `${netPrice(price)} ${TEXT.netSuffix}`).join(' / ')
const multiplyPrices = (prices, quantity) => prices.map(price => ({ ...price, amountMinor: price.amountMinor * quantity }))
const totalPrices = items => {
	const totals = new Map()
	items.flatMap(item => item.totalPrices).forEach(price => {
		const current = totals.get(price.currency)
		if (!current) totals.set(price.currency, { ...price })
		else if (current.minorUnit === price.minorUnit) current.amountMinor += price.amountMinor
	})
	return [...totals.values()]
}
const EMPTY_PRICES = [{ currency: DISPLAY_CURRENCY, amountMinor: 0, minorUnit: 2, taxIncluded: true, taxRateBps: 0 }]

const FIELD_GROUPS = {
	company: [
		'company_name_custom',
		'ico_custom',
		'dic_custom',
		'ic_dph_custom',
		'billing_street_custom',
		'billing_zip_custom',
		'billing_city_custom',
		'billing_country_custom',
		'bank_account_custom'
	],
	delivery: [
		'delivery_same_custom',
		'delivery_company_custom',
		'delivery_street_custom',
		'delivery_zip_custom',
		'delivery_city_custom',
		'delivery_country_custom',
		'delivery_contact_custom',
		'delivery_phone_custom'
	],
	contact: ['meno', 'priezvisko', 'email', 'telefon'],
	personalization: ['doklad'],
	note: ['sprava']
}

const DELIVERY_DETAIL_FIELDS = FIELD_GROUPS.delivery.slice(1)

const AUTOCOMPLETE = {
	company_name_custom: 'organization',
	billing_street_custom: 'street-address',
	billing_zip_custom: 'postal-code',
	billing_city_custom: 'address-level2',
	billing_country_custom: 'country-name',
	delivery_company_custom: 'organization',
	delivery_street_custom: 'street-address',
	delivery_zip_custom: 'postal-code',
	delivery_city_custom: 'address-level2',
	delivery_country_custom: 'country-name',
	delivery_contact_custom: 'name',
	delivery_phone_custom: 'tel',
	meno: 'given-name',
	priezvisko: 'family-name',
	email: 'email',
	telefon: 'tel'
}

export default class B2BProposalForm {
	constructor(root) {
		this.root = root
		this.context = root.querySelector(`[data-sf-instance="${FORM_ID}"]`)
		this.form = this.context?.querySelector('form')
		this.productField = this.form?.querySelector('[data-sf-field="products_custom"]')
		this.summary = null
	}

	init() {
		if (!this.form || !this.productField || this.root.classList.contains('is-enhanced')) return

		this.root.classList.add('is-enhanced')
		this.addAutocomplete()
		this.buildFormStructure()
		this.enhanceProductCards()
		this.setupConditionalFields()
		this.setupValidation()
		this.setupFormReset()
		this.updateSelectionSummary()
	}

	fieldWrapper(fieldId) {
		const field = this.form.querySelector(`#${fieldId}`) || this.form.querySelector(`[name="${fieldId}"]`)
		return field?.closest('[class^="width-"], [class*=" width-"]') || null
	}

	addAutocomplete() {
		Object.entries(AUTOCOMPLETE).forEach(([fieldId, value]) => {
			const field = this.form.querySelector(`#${fieldId}`)
			if (!field) return

			field.setAttribute('autocomplete', value)
			if (fieldId.includes('phone') || fieldId === 'telefon') field.setAttribute('inputmode', 'tel')
		})
	}

	createSection({ id, step, title, description, fields }) {
		const section = document.createElement('section')
		const headingId = `${id}-heading`
		section.className = 'b2b-v2__form-section'
		section.id = id
		section.setAttribute('aria-labelledby', headingId)

		const header = document.createElement('header')
		header.className = 'b2b-v2__form-section-header'
		header.innerHTML = `
			<p class="b2b-v2__form-step">${step}</p>
			<div>
				<h2 id="${headingId}">${title}</h2>
				${description ? `<p>${description}</p>` : ''}
			</div>
		`

		const fieldGrid = document.createElement('div')
		fieldGrid.className = 'b2b-v2__field-grid'
		fields.forEach(fieldId => {
			const wrapper = this.fieldWrapper(fieldId)
			if (wrapper) fieldGrid.append(wrapper)
		})

		section.append(header, fieldGrid)
		return section
	}

	buildFormStructure() {
		const fieldsContainer = this.form.querySelector('.fields-container')
		const checkboxes = this.form.querySelector('.checkboxes-div')
		const formGroup = fieldsContainer?.parentElement
		const productWrapper = this.productField.closest('[class^="width-"], [class*=" width-"]')
		if (!fieldsContainer || !checkboxes || !formGroup || !productWrapper) return

		const productSection = document.createElement('section')
		productSection.className = 'b2b-v2__form-section b2b-v2__form-section--products'
		productSection.id = 'b2b-vyber'
		const productStep = document.createElement('p')
		productStep.className = 'b2b-v2__form-step'
		productStep.textContent = TEXT.productStep
		productSection.append(productStep, productWrapper)

		const companySection = this.createSection({
			id: 'b2b-firma',
			step: TEXT.companyStep,
			title: TEXT.companyTitle,
			description: TEXT.companyDescription,
			fields: FIELD_GROUPS.company
		})
		const deliverySection = this.createSection({
			id: 'b2b-dodanie',
			step: TEXT.deliveryStep,
			title: TEXT.deliveryTitle,
			description: TEXT.deliveryDescription,
			fields: FIELD_GROUPS.delivery
		})
		const contactSection = this.createSection({
			id: 'b2b-kontakt',
			step: TEXT.contactStep,
			title: TEXT.contactTitle,
			description: TEXT.contactDescription,
			fields: FIELD_GROUPS.contact
		})
		const personalizationSection = this.createSection({
			id: 'b2b-personalizacia',
			step: TEXT.personalizationStep,
			title: TEXT.personalizationTitle,
			description: TEXT.personalizationDescription,
			fields: FIELD_GROUPS.personalization
		})
		const finalSection = this.createSection({
			id: 'b2b-odoslanie',
			step: TEXT.submitStep,
			title: TEXT.submitTitle,
			description: TEXT.submitDescription,
			fields: FIELD_GROUPS.note
		})

		const reassurance = document.createElement('p')
		reassurance.className = 'b2b-v2__reassurance'
		reassurance.textContent = TEXT.reassurance
		finalSection.querySelector('.b2b-v2__field-grid').append(reassurance, checkboxes)

		fieldsContainer.replaceChildren(
			productSection,
			companySection,
			deliverySection,
			contactSection,
			personalizationSection,
			finalSection
		)

		const layout = document.createElement('div')
		layout.className = 'b2b-v2__form-layout'
		formGroup.insertBefore(layout, fieldsContainer)
		layout.append(fieldsContainer)
		this.summary = this.createSelectionSummary()
		this.root.append(this.summary)
	}

	createSelectionSummary() {
		const summary = document.createElement('details')
		summary.className = 'b2b-v2__selection-summary'
		summary.innerHTML = `
			<summary>
				<span class="b2b-v2__summary-label">${TEXT.summaryLabel}</span>
				<span class="b2b-v2__summary-compact">
					<strong data-b2b-summary-count>${interpolate(TEXT.productMany, { count: 0 })}</strong>
					<span aria-hidden="true">·</span>
					<strong data-b2b-summary-pieces>${interpolate(TEXT.pieces, { count: 0 })}</strong>
					<span aria-hidden="true">·</span>
					<strong data-b2b-summary-total>${dualPrice(EMPTY_PRICES)}</strong>
				</span>
				<span class="b2b-v2__summary-chevron" aria-hidden="true"></span>
			</summary>
			<div class="b2b-v2__selection-summary-body">
				<p data-b2b-summary-empty>${TEXT.summaryEmpty}</p>
				<ul data-b2b-summary-list></ul>
				<div class="b2b-v2__summary-grand-total">
					<span data-b2b-summary-total-label>${TEXT.summaryTotal}</span>
					<strong data-b2b-summary-grand-total>${dualPrice(EMPTY_PRICES)}</strong>
				</div>
				<a href="#b2b-vyber" class="b2b-v2__summary-link">${TEXT.summaryEdit}</a>
			</div>
		`

		return summary
	}

	enhanceProductCards() {
		this.productField.querySelectorAll('[data-sf-vqc-item]').forEach(card => {
			const checkbox = card.querySelector('[data-sf-vqc-checkbox]')
			const rule = card.querySelector('.dttm-sf-visual-quantity__rule')
			const description = card.querySelector('.dttm-sf-visual-quantity__item-description')
			const unitPrices = normalizePrices(card)
			const details = card.querySelector('.dttm-sf-visual-quantity__dialog--info .dttm-sf-visual-quantity__dialog-content')
			const infoButton = card.querySelector('.dttm-sf-visual-quantity__info')
			const previewButton = card.querySelector('[data-sf-vqc-preview]')
			if (!checkbox) return

			card.classList.add('is-clickable')
			card.dataset.b2bProduct = checkbox.value
			if (checkbox.value === GIFT_BAG_PRODUCT_ID) {
				this.setupGiftBag(card)
				return
			}
			this.enhanceQuantityControl(card, checkbox)
			rule?.remove()
			const price = card.querySelector('[data-sf-vqc-unit-prices]')
			if (description && price && unitPrices.length) {
				price.classList.add('b2b-v2__demo-price')
				price.setAttribute('data-b2b-demo-price', '')
				price.innerHTML = `
					<span class="b2b-v2__demo-price-label">${TEXT.pricePerUnit}</span>
					<strong>${dualPrice(unitPrices)}</strong>
					<small class="b2b-v2__demo-price-net">${netDualPrice(unitPrices)}</small>
				`
			}
			if (details?.textContent.includes(TEXT.placeholderDetails)) {
				infoButton?.setAttribute('hidden', '')
			}
			if (previewButton) {
				previewButton.addEventListener('click', () => {
					window.requestAnimationFrame(() => {
						const dialogId = previewButton.getAttribute('aria-controls')
						const dialog = dialogId ? document.getElementById(dialogId) : null
						const title = dialog?.querySelector('[data-sf-vqc-dialog-title]')
						const productTitle = previewButton.getAttribute('data-sf-vqc-preview-label')?.trim()
						if (title && productTitle) title.textContent = productTitle
					})
				})
			}

			card.addEventListener('click', event => {
				if (event.target.closest('button, input, label, a, dialog')) return
				checkbox.click()
			})
		})

		this.form.addEventListener('change', event => {
			if (!event.target.matches('[data-sf-vqc-checkbox], [data-sf-vqc-quantity]')) return
			this.syncGiftBag()
			this.updateSelectionSummary()
			this.syncPersonalization()
		})
		this.form.addEventListener('input', event => {
			if (!event.target.matches('[data-sf-vqc-quantity]')) return
			this.syncGiftBag()
			this.updateSelectionSummary()
		})
	}

	setupGiftBag(card) {
		this.giftBag = card
		card.classList.add('b2b-v2__gift-bag')
		card.classList.remove('is-clickable')
		card.querySelector('.dttm-sf-visual-quantity__media')?.remove()
		card.querySelector('.dttm-sf-visual-quantity__rule')?.remove()
		const label = card.querySelector('.dttm-sf-visual-quantity__choice label')
		if (label) label.textContent = TEXT.giftBagChoice
		const quantity = card.querySelector('[data-sf-vqc-quantity]')
		quantity.readOnly = true
		quantity.tabIndex = -1
		const description = card.querySelector('.dttm-sf-visual-quantity__item-description')
		if (description) {
			description.id = `${quantity.id}-description`
			card.querySelector('[data-sf-vqc-checkbox]').setAttribute('aria-describedby', description.id)
		}
		const price = card.querySelector('[data-sf-vqc-unit-prices]')
		if (price) {
			price.className = 'dttm-sf-visual-quantity__unit-prices b2b-v2__gift-bag-price'
			price.textContent = `${dualPrice(normalizePrices(card))} ${TEXT.giftBagUnit}`
		}
		const count = document.createElement('output')
		count.className = 'b2b-v2__gift-bag-count'
		count.setAttribute('aria-live', 'polite')
		count.setAttribute('aria-label', TEXT.giftBagCountAria)
		card.append(count)
		// Keep the native item inside its field, outside the eight-product grid.
		this.productField.querySelector('.dttm-sf-visual-quantity__grid').after(card)
		this.syncGiftBag()
	}

	syncGiftBag() {
		if (!this.giftBag) return
		const parent = this.productField.querySelector(`[data-sf-vqc-item="${PERSONALIZED_PRODUCT_ID}"]`)
		const available = Boolean(parent?.querySelector('[data-sf-vqc-checkbox]')?.checked)
		const checkbox = this.giftBag.querySelector('[data-sf-vqc-checkbox]')
		const quantity = this.giftBag.querySelector('[data-sf-vqc-quantity]')
		const parentQuantity = parent?.querySelector('[data-sf-vqc-quantity]')?.value || ''
		this.giftBag.hidden = !available
		checkbox.disabled = !available
		if (!available) checkbox.checked = false
		quantity.disabled = !checkbox.checked
		quantity.value = checkbox.checked ? parentQuantity : ''
		this.giftBag.classList.toggle('is-selected', checkbox.checked)
		this.giftBag.querySelector('.b2b-v2__gift-bag-count').textContent = available ? `${parentQuantity || '—'} ks` : ''
	}

	enhanceQuantityControl(card, checkbox) {
		const row = card.querySelector('[data-sf-vqc-quantity-row]')
		const input = card.querySelector('[data-sf-vqc-quantity]')
		const choice = card.querySelector('.dttm-sf-visual-quantity__choice')
		const productLabel = choice?.querySelector('label')?.textContent.trim() || TEXT.selectedProduct
		if (!row || !input) return

		row.classList.add('b2b-v2__quantity-inline')
		if (choice && row.parentElement !== choice) checkbox.after(row)
		if (row.querySelector('[data-b2b-quantity-step]')) return

		const createButton = (direction, symbol, action) => {
			const button = document.createElement('button')
			button.type = 'button'
			button.className = 'b2b-v2__quantity-stepper-button'
			button.dataset.b2bQuantityStep = direction
			button.setAttribute('aria-label', `${action} ${TEXT.quantityFor} ${productLabel}`)
			button.setAttribute('aria-controls', input.id)
			button.textContent = symbol
			return button
		}

		const decrease = createButton('decrease', '−', TEXT.decreaseQuantity)
		const increase = createButton('increase', '+', TEXT.increaseQuantity)
		input.before(decrease)
		input.after(increase)

		const syncButtons = () => {
			const value = Number(input.value)
			const minimum = Number(input.min || 1)
			const maximum = Number(input.max || Number.MAX_SAFE_INTEGER)
			decrease.disabled = input.disabled || !Number.isFinite(value) || value <= minimum
			increase.disabled = input.disabled || !Number.isFinite(value) || value >= maximum
		}

		const applyStep = direction => {
			if (input.disabled) return
			try {
				if (direction === 'increase') input.stepUp()
				else input.stepDown()
			} catch (error) {
				return
			}
			input.dispatchEvent(new Event('input', { bubbles: true }))
			input.dispatchEvent(new Event('change', { bubbles: true }))
			syncButtons()
		}

		decrease.addEventListener('click', () => applyStep('decrease'))
		increase.addEventListener('click', () => applyStep('increase'))
		input.addEventListener('input', syncButtons)
		input.addEventListener('change', syncButtons)
		checkbox.addEventListener('change', () => window.requestAnimationFrame(syncButtons))
		syncButtons()
	}

	setupConditionalFields() {
		this.deliveryRadios = Array.from(this.form.querySelectorAll('input[name="delivery_same_custom"]'))
		this.deliveryWrappers = DELIVERY_DETAIL_FIELDS.map(fieldId => this.fieldWrapper(fieldId)).filter(Boolean)
		this.personalizationSection = this.form.querySelector('#b2b-personalizacia')
		this.logoWrapper = this.fieldWrapper('doklad')

		const radioGroup = this.form.querySelector('.delivery_same_custom.input-group')
		const radioLabel = radioGroup?.querySelector('.label-wrapper')
		if (radioGroup && radioLabel) {
			radioLabel.id = 'delivery_same_custom_label'
			radioGroup.setAttribute('role', 'group')
			radioGroup.setAttribute('aria-labelledby', radioLabel.id)
			radioGroup.setAttribute('aria-required', 'true')
		}

		this.deliveryRadios.forEach(radio => radio.addEventListener('change', () => this.syncDeliveryFields()))
		if (!this.deliveryRadios.some(radio => radio.checked)) {
			const yes = this.deliveryRadios.find(radio => radio.value === DELIVERY_SAME_YES_VALUE)
			if (yes) yes.checked = true
		}

		this.syncDeliveryFields()
		this.syncPersonalization()
	}

	setRequiredState(wrapper, active, required) {
		if (!wrapper) return
		wrapper.hidden = !active
		wrapper.setAttribute('aria-hidden', active ? 'false' : 'true')

		wrapper.querySelectorAll('input, textarea, select').forEach(field => {
			field.disabled = !active
			field.required = active && required
			if (!active) {
				field.removeAttribute('aria-invalid')
				field.classList.remove('invalid')
				const error = field.parentElement?.querySelector('.error-field') || field.nextElementSibling
				if (error?.classList.contains('error-field')) error.style.display = 'none'
			}
		})

		const labelText = wrapper.querySelector('.label-text')
		let marker = labelText?.querySelector('.b2b-v2__conditional-required')
		if (active && required && labelText && !marker) {
			marker = document.createElement('span')
			marker.className = 'mark-required b2b-v2__conditional-required'
			marker.setAttribute('aria-hidden', 'true')
			marker.textContent = ' *'
			labelText.append(marker)
		} else if ((!active || !required) && marker) {
			marker.remove()
		}
	}

	syncDeliveryFields() {
		const selected = this.deliveryRadios.find(radio => radio.checked)
		const needsDeliveryAddress = selected?.value === DELIVERY_SAME_NO_VALUE
		this.deliveryWrappers.forEach(wrapper => this.setRequiredState(wrapper, needsDeliveryAddress, true))
	}

	syncPersonalization() {
		const personalized = this.productField.querySelector(`[data-sf-vqc-checkbox][value="${PERSONALIZED_PRODUCT_ID}"]`)
		const isSelected = Boolean(personalized?.checked)
		if (this.personalizationSection) {
			this.personalizationSection.hidden = !isSelected
			this.personalizationSection.setAttribute('aria-hidden', isSelected ? 'false' : 'true')
		}
		this.setRequiredState(this.logoWrapper, isSelected, true)
	}

	selectedProducts() {
		return Array.from(this.productField.querySelectorAll('[data-sf-vqc-item]'))
			.map(card => {
				const checkbox = card.querySelector('[data-sf-vqc-checkbox]')
				if (!checkbox?.checked) return null
				const quantity = Number.parseInt(card.querySelector('[data-sf-vqc-quantity]')?.value, 10) || 0
				const isGiftBag = checkbox.value === GIFT_BAG_PRODUCT_ID
				const unitPrices = normalizePrices(card)
				return {
					isGiftBag,
					label: isGiftBag ? TEXT.giftBagName : card.querySelector('.dttm-sf-visual-quantity__choice > label')?.textContent.trim() || TEXT.selectedPackage,
					quantity,
					unitPrices,
					totalPrices: multiplyPrices(unitPrices, quantity)
				}
			})
			.filter(Boolean)
	}

	selectionCountLabel(count) {
		if (count === 1) return interpolate(TEXT.productOne, { count })
		if (count >= 2 && count <= 4) return interpolate(TEXT.productFew, { count })
		return interpolate(TEXT.productMany, { count })
	}

	updateSelectionSummary() {
		if (!this.summary) return
		const selected = this.selectedProducts()
		const products = selected.filter(item => !item.isGiftBag)
		const giftBag = selected.find(item => item.isGiftBag)
		const count = this.summary.querySelector('[data-b2b-summary-count]')
		const pieces = this.summary.querySelector('[data-b2b-summary-pieces]')
		const total = this.summary.querySelector('[data-b2b-summary-total]')
		const grandTotal = this.summary.querySelector('[data-b2b-summary-grand-total]')
		const empty = this.summary.querySelector('[data-b2b-summary-empty]')
		const list = this.summary.querySelector('[data-b2b-summary-list]')
		const totalPieces = products.reduce((sum, item) => sum + item.quantity, 0)
		const totals = totalPrices(selected)
		count.textContent = this.selectionCountLabel(products.length)
		pieces.textContent = giftBag
			? interpolate(TEXT.piecesWithBags, { pieces: totalPieces, bags: giftBag.quantity })
			: interpolate(TEXT.pieces, { count: totalPieces })
		total.textContent = dualPrice(totals.length ? totals : EMPTY_PRICES)
		grandTotal.textContent = dualPrice(totals.length ? totals : EMPTY_PRICES)
		empty.hidden = selected.length > 0
		list.replaceChildren(...selected.map(item => {
			const row = document.createElement('li')
			const copy = document.createElement('span')
			const label = document.createElement('strong')
			const meta = document.createElement('small')
			const itemTotal = document.createElement('strong')
			copy.className = 'b2b-v2__summary-item-copy'
			label.textContent = item.label
			meta.textContent = `${item.quantity} ks × ${dualPrice(item.unitPrices)}`
			itemTotal.textContent = dualPrice(item.totalPrices)
			copy.append(label, meta)
			row.append(copy, itemTotal)
			return row
		}))
	}

	setupFormReset() {
		this.form.addEventListener('reset', () => {
			window.requestAnimationFrame(() => {
				this.syncGiftBag()
				this.updateSelectionSummary()
				this.syncDeliveryFields()
				this.syncPersonalization()
				if (this.summary) this.summary.open = false
			})
		})
	}

	setupValidation() {
		this.form.addEventListener('submit', event => {
			this.syncGiftBag()
			const missing = []
			const needsDeliveryAddress = this.deliveryRadios.find(radio => radio.checked)?.value === DELIVERY_SAME_NO_VALUE
			if (needsDeliveryAddress) {
				DELIVERY_DETAIL_FIELDS.forEach(fieldId => {
					const field = this.form.querySelector(`#${fieldId}`)
					if (field && !field.value.trim()) missing.push(field)
				})
			}

			const personalized = this.productField.querySelector(`[data-sf-vqc-checkbox][value="${PERSONALIZED_PRODUCT_ID}"]`)
			const logo = this.form.querySelector('#doklad')
			if (personalized?.checked && logo && !logo.files?.length) missing.push(logo)

			if (!missing.length) return

			event.preventDefault()
			event.stopImmediatePropagation()
			missing.forEach(field => this.markInvalid(field))
			this.showConditionalErrorSummary(missing)
			missing[0].focus()
			missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
		}, true)

		this.form.addEventListener('input', event => this.clearInvalid(event.target))
		this.form.addEventListener('change', event => this.clearInvalid(event.target))
		this.form.addEventListener('submit', () => {
			window.setTimeout(() => this.repairErrorSummary(), 0)
		})
	}

	markInvalid(field) {
		field.classList.add('invalid')
		field.setAttribute('aria-invalid', 'true')
		const group = field.closest('.input-group')
		const error = group?.querySelector('.error-field')
		if (error) error.style.display = 'block'
		if (field.type === 'file') this.form.querySelector('#uploadButton')?.classList.add('invalid')
	}

	clearInvalid(field) {
		if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) return
		const hasValue = field.type === 'file' ? Boolean(field.files?.length) : Boolean(field.value.trim())
		if (!hasValue) return
		field.classList.remove('invalid')
		field.removeAttribute('aria-invalid')
		const error = field.closest('.input-group')?.querySelector('.error-field')
		if (error) error.style.display = 'none'
		if (field.type === 'file') this.form.querySelector('#uploadButton')?.classList.remove('invalid')
	}

	showConditionalErrorSummary(fields) {
		const summary = this.form.querySelector('#summary-error')
		if (!summary) return
		const heading = document.createElement('strong')
		heading.textContent = TEXT.requiredHeading
		const list = document.createElement('ul')
		fields.forEach(field => {
			const item = document.createElement('li')
			item.textContent = field.closest('.input-group')?.querySelector('.label-text')?.textContent.trim() || field.name
			list.append(item)
		})
		summary.replaceChildren(heading, list)
		summary.style.display = 'block'
	}

	repairErrorSummary() {
		const summary = this.form.querySelector('#summary-error')
		if (!summary) return

		const messages = [...this.form.querySelectorAll('.error-field')]
			.filter(error => window.getComputedStyle(error).display !== 'none' && error.textContent.trim())
			.map(error => {
				const group = error.closest('.input-group')
				const label = group?.querySelector('.label-text, .checkbox-text, label')?.textContent
					.replace(/\s+/g, ' ')
					.replace(/\s*\*\s*$/, '')
					.replace(/[.:;!?]+$/, '')
					.trim()
				const message = error.textContent.replace(/\s+/g, ' ').trim()
				return label ? `${label}: ${message}` : message
			})
		if (!messages.length) return

		let items = [...summary.querySelectorAll('li')]
		if (!items.length) {
			const heading = document.createElement('strong')
			heading.textContent = window.sutazny_formular_data?.form_errors || TEXT.formErrors
			const list = document.createElement('ul')
			messages.forEach(message => {
				const item = document.createElement('li')
				item.textContent = message
				list.append(item)
			})
			summary.replaceChildren(heading, list)
			summary.style.display = 'block'
			items = [...list.children]
		}

		items.forEach((item, index) => {
			if (messages[index] && item.textContent.trim() !== messages[index]) item.textContent = messages[index]
			else if (!item.textContent.trim()) item.remove()
		})
	}
}
